// src/core/workbook/annotationDB.js

const DB_NAME = 'edu-workbook-annotations';
const DB_VERSION = 1;
const STORE = 'annotations';

const openDB = () => new Promise((resolve, reject) => {
  const req = indexedDB.open(DB_NAME, DB_VERSION);
  req.onupgradeneeded = (e) => {
    const db = e.target.result;
    if (!db.objectStoreNames.contains(STORE)) {
      const store = db.createObjectStore(STORE, { keyPath: 'key' });
      store.createIndex('by_user_book', ['userId', 'bookId']);
    }
  };
  req.onsuccess = () => resolve(req.result);
  req.onerror = () => reject(req.error);
});

export const saveAnnotationsLocal = async (userId, bookId, pageNumber, strokes) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readwrite');
    tx.objectStore(STORE).put({
      key: `${userId}_${bookId}_${pageNumber}`,
      userId, bookId, pageNumber, strokes,
      lastModified: Date.now()
    });
    tx.oncomplete = resolve;
    tx.onerror = () => reject(tx.error);
  });
};

export const loadAnnotationsLocal = async (userId, bookId) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readonly');
    const index = tx.objectStore(STORE).index('by_user_book');
    const req = index.getAll([userId, bookId]);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
};